import React, { useState, useEffect } from "react";
import { MDBInput } from "mdb-react-ui-kit";
import ReactDatetime from "react-datetime";
import Select from "react-select";

import {
  Button,
  ButtonGroup,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  FormGroup,
  Form,
  Input,
  Badge,
  Table,
  Row,
  Col,
  Pagination,
  PaginationItem,
  PaginationLink,
  UncontrolledTooltip,
  Modal,
  ModalBody,
  ModalFooter
} from "reactstrap";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import Smile from "../../assets/img/smile.png";
import Attach from "../../assets/img/attach.png";
import Send from "../../assets/img/send1.svg";
import Whatsap from "../../assets/img/whatsapp.svg";


import {
  WHATSAPP_CAMPAIGN_NAMES,
  WHATSAPP_CAMPAIGN_DOWNLOAD,
  WHATSAPP_CAMPAIGN_LIST,
  WHATSAPP_DETAIL_REPORTS,
  IVR_DETAILED_REPORT,
  WHATSAPP_CHAT_HISTORY,
  BASE_URL_CHAT_APP,
  CHANNEL_CLIENT_CHNLTYPE,
  WHATSAPP_USER_RESPONSE_EXCEL,
  IVR_DETAILED_REPORT_EXCEL
} from "../../constants";

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

import axios from "axios";
import moment from "moment";
import NotificationAlert from "react-notification-alert";
import logo from "../../assets/img/logo.png";
import LoadingScreen from "react-loading-screen";
import ResponsivePagination from 'react-responsive-pagination';
import 'react-responsive-pagination/themes/classic.css';

let templates = [];
let senderids = [];
const localJson = localStorage.getItem("user");
const user= JSON.parse(localJson)
const Detailedreports = () => {
  const [search, setSearch] = useState({
    fromdate: "",
    todate: "",
    campaignname:"",
    mobile:"",
    templateid:"",
    senderid:""
  });
  let selectedDate="";
  const [singleSelect, setsingleSelect] = useState(null);
  const [name, setName] = useState([]);
  const [cname, setCName] = useState([]);

  const [showList, setShowList] = useState(false);
  const [whatsappLst, setWhatsappLst] = useState([]);
  const [whatsappLstC, setWhatsappLstC] = useState([]);
  const [chatHistory, setChatHistory] = useState([]);


  const [currentPage, setCurrentPage] = React.useState(1);

  const [validate, setValidate] = useState({
    message: "",
    notValid: false,
  });

  const notificationAlertRef = React.useRef(null);
  const [errorhandle,setErrorHandle]= useState()
  const [isLoading, setIsLoading] = React.useState(false);
  const [drpdwn,setDrpdwn] = useState([])
  const [filterList, setFilterLst] = useState([]);
  const [templateSelect, setTemplateSelect] = useState(null);
  const [selectedDrpdwn,setSelectedDrpdwn] = useState("");
  const [showModal,setShowModal] = useState(false);
  const [sendMsg,setSendMsg]= useState({number:"",message:""})
  const [channel, setChannel] = useState([]);
  const drpdwns=[
    { value: "Inbound", label: "Inbound" },     
    { value: "Outbound", label: "Outbound" }        
    // { value: "1", label: "Campaign Name" },
    // { value: "2", label: "Template Name" },
   
  ]



  useEffect(() => {
    getWhatsappNames();
    fetchChanelsbyClient()
   // getWhatsappList(currentPage);
  }, []);

  const getWhatsappNames = () => {
    axios
      .get(WHATSAPP_CAMPAIGN_NAMES)
      .then((res) => {
        setName(res.data.message);
        setCName(res.data.message);
      })
      .catch((err) => console.log("error===>", err));
  };



  const fetchChanelsbyClient=()=>{
    
    //setIsLoading(true)

    const payload={
      channels_type:"whatsapp",
      clintId:user?.client
    }  
    
     axios.post(CHANNEL_CLIENT_CHNLTYPE,payload).then(res=>{
    
      templates=[]
     
      setChannel( res?.data)
    

      res?.data?.map((wtsap,i)=>{
        wtsap?.template&&templates.push({ value:wtsap?.template, label: wtsap?.template },)
        
      })
      
      setIsLoading(false)
     }).catch(e=>{
      setIsLoading(false)
      let options = {};
          options = {
            place: "tr",
            message: "Templates Not Found",
            type: "warning",
            autoDismiss: 2,
          };
          notificationAlertRef?.current?.notificationAlert(options);
    })

  }

  const changeSender=(data)=>{
    senderids=[]
    const chnl=channel.filter(item=>item.template==data.value)
      
    const senderid = chnl[0]?.senderid?.split(",");
        for(let i=0;i<senderid?.length;i++){
          senderids.push({label:senderid[i],value:senderid[i]})
        }
 

    setSearch(prev=>({...prev,templateid:data,senderid:""}))
  }

  const validating=()=>{
    let errors = {}
    let fromdate = moment(search?.fromdate).format("YYYY-MM-DD");
    let todate = moment(search?.todate).format("YYYY-MM-DD");
    if(!search?.fromdate){
      errors.fromdate="Please Select From Date"
    }if(!search?.todate){
      errors.todate="Please Select To Date"
    }else if(todate < fromdate){
      errors.todate="To date should be greater than or equal to from date"
    }
    if(!singleSelect?.value){
      errors.singleSelect="Please Select Response"
    }
    
    

    return errors;
  }

  const getWhatsappList = (page) => {
    const isValid = validating();
    setErrorHandle(isValid)
    if(Object.keys(isValid).length===0){
    setIsLoading(true);
    const lclStrge= localStorage.getItem("user");
    const user = JSON.parse(lclStrge);
    let fromdate = moment(search.fromdate).format("YYYY-MM-DD");
    let todate = moment(search.todate).format("YYYY-MM-DD");
    const sender_id = user?.sender_id
    const type = singleSelect?.value;
   
    setCurrentPage(page);
    axios
     // .get(WHATSAPP_USER_RESPONSE + `?fromdate=${fromdate}&todate=${todate}&campaign=${search?.campaignname}&template=${search?.templateid?.value}&mobile=${search.mobile}&senderid=${search?.senderid?.value}&page=` + page)
     .get(IVR_DETAILED_REPORT + `?fromdate=${fromdate}&todate=${todate}&page=${page}&type=${type}`)
     
     .then((res) => {
        setWhatsappLst(res.data);
        setWhatsappLstC(res.data)
        setIsLoading(false);
        setFilterLst(res.data);
      })
      .catch((err) => {
        console.log("error===>", err);
        setIsLoading(false);
      });
    }
  };



  const generateXcel = (page) => {
    const isValid = validating();
    setErrorHandle(isValid)
    if(Object.keys(isValid).length===0){
    if (search?.fromdate) {
      let selectedDate = moment(search.date).format("YYYY-MM-DD");

      const lclStrge= localStorage.getItem("user");
      const user = JSON.parse(lclStrge);
      let fromdate = moment(search.fromdate).format("YYYY-MM-DD");
      let todate = moment(search.todate).format("YYYY-MM-DD");
      const sender_id = user?.sender_id;
      const type = singleSelect?.value;
      setIsLoading(true);
      setCurrentPage(page);
      axios
      //  .get(WHATSAPP_USER_RESPONSE + `?fromdate=${fromdate}&todate=${todate}&campaign=${search.campaignname}&template=${search?.template}&mobile=${search.mobile}&senderid=${user.sender_id}&page=` + page)
      .get(IVR_DETAILED_REPORT_EXCEL + `?fromdate=${fromdate}&todate=${todate}&page=${page}&type=${type}`)
    
        .then((res) => {
          setIsLoading(false);
          exportToCSV(res.data.message);
        })
        .catch((err) => {
          let options = {};
          options = {
            place: "tr",
            message: err.response.data.message,
            type: "warning",

            autoDismiss: 3,
          };
          notificationAlertRef.current.notificationAlert(options);
          setIsLoading(false);
        });
      }
    } else {
      setValidate({
        message: "please enter details",
        notValid: true,
      });
    }
  };

  const exportToCSV = (apiData) => {
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const ws = XLSX.utils.json_to_sheet(apiData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, search.fromdate + fileExtension);
  };

  

  const filterData = (e) => {
    let filter = e.target.value;
    // let a = filterList?.message.filter((item,index)=>{console.log(typeof(c)) })
    let a = whatsappLstC?.message?.filter(item => item?.msisdn?.includes(filter));
   
   setWhatsappLst({
    message:a
   })
  };

  const toDatevalidation = (todt) => {
    setSearch({ ...search, todate: todt });
    let fromdate = moment(search.fromdate).format("YYYY-MM-DD");
    let todate = moment(todt).format("YYYY-MM-DD");

    if (todate >= fromdate) {
      setValidate({
        message: "",
        notValid: false,
      });
    } else {
      setValidate({
        message: "To date should be greater than or equal to from date",
        notValid: true,
      });
    }
  };



  const getChatHistory=(num,selectdate)=>{
    selectedDate=selectdate;
    let payload={
      msisdn:num,
      date:moment(selectdate).format("YYYY-MM-DD")
    }
    axios.post(WHATSAPP_CHAT_HISTORY,payload).then((res)=>{setChatHistory(res?.data?.message);setShowModal(true);
      setSendMsg({...sendMsg ,number:num})}).catch((error)=>console.log("Chat history error==>",error))
  }

  const sendMessage=async()=>{
    let lclstrg = localStorage.getItem("user");
    let user = JSON.parse(lclstrg);
    let formatType = "text";
   let payload = {
        messaging_product: "whatsapp",
        preview_url: false,
        recipient_type: "individual",
        to: sendMsg.number,
        type: formatType,
        sender_id: user.sender_id,
        text: {
          body: sendMsg.message,
        },
      }

      // Adding headers to the request
      
   
   
    let obj = await axios.post(BASE_URL_CHAT_APP + "/graphapi", payload)
      .then((res) => {
        setShowModal(false);
        setSendMsg({number:"",message:""})
      console.log("log...",res)
      }
      )
     
      .catch((err) => {});
  }

  return (
    <>
      <div className="content pb-0">
        <LoadingScreen
          children=""
          loading={isLoading}
          bgColor="rgba(0,0,0,0.7)"
          spinnerColor="#9ee5f8"
          textColor="#676767"
          logoSrc={logo}
          text="Loading..."
        ></LoadingScreen>
        <Row>
          <Col md="12">
            <Card className="mb-2">
              <CardBody>
                <NotificationAlert ref={notificationAlertRef} />
                <Row>
                
                  <Col md="2" sm="12">
                    <p className="category">From Date</p>
                    <ReactDatetime
                      inputProps={{
                        className: "form-control",
                        placeholder: "Date",
                      }}
                      closeOnSelect={true}
                      timeFormat={false}
                      value={search.fromdate}
                      onChange={(val) => {
                        setSearch({ ...search, fromdate: val._d });
                       
                      }}
                    />
                     <span style={{color:"red"}}>{errorhandle?.fromdate}</span>
                  </Col>
                  <Col md="2" sm="12">
                    <p className="category">To Date</p>
                    <ReactDatetime
                      inputProps={{
                        className: "form-control",
                        placeholder: "Date",
                      }}
                      closeOnSelect={true}
                      timeFormat={false}
                      value={search.todate}
                      onChange={(val) => {
                        setSearch({ ...search, todate: val._d });
                        toDatevalidation(val._d);
                      }}
                    
                    />
                   <span style={{color:"red"}}>{errorhandle?.todate}</span>
                  </Col>
                  <Col md="2" sm='12'>
                    <p className="category">Select </p>
                  <Select
                          className="react-select info"
                          classNamePrefix="react-select"
                          name="singleSelect"
                          value={singleSelect}
                          onChange={(value) => {setsingleSelect(value);}}
                          options={drpdwns}
                          placeholder="Select"
                        />
                        <span style={{color:"red"}}>{errorhandle?.singleSelect}</span>
                    </Col>
                    
                   { 
                   singleSelect?.value==2&&
                   <>
                   <Col md="4" sm="12">
                   <p className="category">Select Template<suf style={{color:"red"}}>*</suf> </p>
                   <Select
                     className="react-select info"
                     classNamePrefix="react-select"
                     name="templateSelect"
                     value={search.templateid}
                     onChange={(value) => changeSender(value)}
                     options={templates}
                     placeholder="Select"
                   />
                   {errorhandle?.templateid&&<span style={{color:"red"}}>{errorhandle?.templateid}</span>}
                 </Col>
                 <Col md="4" sm="12">
                   <p className="category">Select Sender<suf style={{color:"red"}}>*</suf> </p>
                   <Select
                     className="react-select info"
                     classNamePrefix="react-select"
                     name="senderSelect"
                     value={search?.senderid}
                     onChange={(value) => setSearch(prev=>({...prev,senderid:value}))}
                     options={senderids}
                     placeholder="Select"
                   />
                    {errorhandle?.senderid&&<span style={{color:"red"}}>{errorhandle?.senderid}</span>}
                 </Col>
                 </>
                    }
                  <Col md="2" sm="6" className="pull-right">
                  <Button
                      color="primary "
                      className="mt-4 btn btn-icon animation-on-hover"
                      id="tooltipsubmit"
                      type="button"
                      onClick={() => getWhatsappList(currentPage)}
                    >
                      <i className="tim-icons icon-double-right" />
                    </Button>
                    <UncontrolledTooltip
                      delay={0}
                      placement="top"
                      target="tooltipsubmit"
                    >
                      Submit
                    </UncontrolledTooltip>
                    <Button
                      className=" btn-primary  btn-simple btn-icon btn-round mt-4"
                      color="primary"
                      data-placement="top"
                      id="tooltippdf"
                      type="button"
                      onClick={() => generateXcel(currentPage)}
                    >
                      <i className="tim-icons icon-cloud-download-93" />
                    </Button>
                   
                    <UncontrolledTooltip
                      delay={0}
                      placement="top"
                      target="tooltippdf"
                    >
                      Export
                    </UncontrolledTooltip>
                  </Col>

                  
                </Row>
              
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col className="mb-0" md="12">
            <Card className="mb-0">
            <Row>
                  <Col md="10"></Col>
                <Col md="2" sm="12" >
                    <MDBInput
                      label="Search"
                      placeholder="enter mobile number"
                      type="text"
                      onChange={(e) => filterData(e)}
                    />
                  </Col>
                </Row>
              <CardBody className="mb-0">
              <Modal isOpen={showModal} className="roles-popup">
          <div
            className="modal-header justify-content-center"
            style={{ backgroundColor: " rgba(233, 233, 233, 0.9294117647)" }}
          >
            <button
              aria-hidden={true}
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => setShowModal(false)}
            >
              <i className="tim-icons icon-simple-remove" />
            </button>
            <h3 className="title title-up multicolortext">
              Chat Histoty of {moment(chatHistory[0]?.time).format("YYYY-MM-DD")}
              
            </h3>
          </div>
          <ModalBody className="modelbody">
            <div className="chatBody" style={{height:"420px"}}>
              <div className="userinfo">
                <p>Agent </p>

                <p>User </p>
              </div>
                      {
                        chatHistory.map((item,index)=>{
                          return(
                            <>
                              {
                                item?.from_msg===1?<Row>
                                <Col md="5" sm="12" className="mt-2">
                                  {" "}
                                  <div className="messageto">
                                    <div className="messageContent">
                                      
                                          <p>{item?.message_body}</p>
                                          <div style={{ fontSize: "12px" }}>
                                            {moment(item?.time).format("hh:mm A")}
                                          </div>
                                       
                                    </div>
                                  </div>
                                </Col>
                                <Col md="7" sm="12" className="mt-2"></Col>
                              </Row>:
                              <Row>
                              <Col md="7" sm="12" className="mt-2"></Col>
                              <Col md="5" sm="12" className="mt-2">
                                <div className="messagefrom">
                                  <div className="messageContent">
                                   
                                        <p  style={{
                                            color: "white",
                                            fontSize: "12px",
                                          }}> {item?.message_body}</p>
                                        <div
                                          style={{
                                            color: "black",
                                            fontSize: "12px",
                                          }}
                                        >
                                          <span>
                                          {moment(item?.time).format("hh:mm A")}
                                          </span>
                                        </div>
                                  </div>
                                </div>
                              </Col>
                            </Row>
                              }
                            </>
                          )
                        })
                      }
                        
                        
            </div>
          </ModalBody>
          <ModalFooter >
          <Row style={{width:"100%"}}>
                    
                    <Col sm="12" className="mb-2 mt-2" >
                      
                      <FormGroup style={{border:"1px solid #e1e0e0",borderRadius:"30px",display:"flex",flexDirection:"row"}}>
                      <label
                  onClick={() => {
                    //setIsEmojiShow(true);
                  }}
                  style={{ padding:"5px" }}
                >
                  <img src={Smile} alt="" />
                </label>
                <input
                  type="file"
                  style={{ display: "none" }}
                  id="file"
                  accept=".xlsx,.xls,image/png,image/jpeg,.doc, .docx,.ppt, .pptx,.txt,.pdf,.mp4"
                  onChange={(e) => {
                    // setImg(e.target.files[0]);
                    //uploadImg(e.target.files[0], client.msisdn);
                  }}
                />
                <label htmlFor="file" style={{ width: "23px",marginTop:"7px" }}>
                  <img src={Attach} alt="" />
                </label>
                        <Input
                        style={{border:"none"}}
                          label="Message "
                          type="text"
                          placeholder="type here"
                          //maxLength={160}
                         value={sendMsg.message}
                          onChange={(e) =>
                            setSendMsg({ ...sendMsg, message: e.target.value })
                          }
                          
                        />
                          <button
                    onClick={() => sendMessage()}
                    style={{padding:"0px",border:"none",height:"40px",width:"40px",background:"#1d8864",borderRadius:"25px",color:"white",lineHeight:"38px",cursor:"pointer"}}
                  >
                    <label style={{ width: "30px" }}>
                      <img src={Send} alt="" />
                    </label>
                    
                  </button>
                      </FormGroup>
                    </Col>
             
                </Row>
          </ModalFooter>
        </Modal>
                <TableContainer component={Paper} className="tableheight">
                  <Table
                    sx={{  paddingBottom: 0 }}
                    aria-label="simple table"
                    responsive
                    striped
                  >
                    <thead>
                      <tr>
                        <th >S no </th>
                        <th > Date Time</th>
                        <th > Mobile No</th>
                        {/* <th > Duration</th> */}
                        <th > Status</th>
                        <th > Response</th>

                        
                       
                      </tr>
                      {/* <tr>
                        <th> Sent Messages</th>
                      </tr> */}
                    </thead>
                    <tbody>
                      {whatsappLst?.message?.length > 0 ? (
                        whatsappLst?.message?.map((item, index) => {
                          return (
                            <>
                              <tr>
                                <td style={{width:"5%"}}>{index+1}</td>
                                <td style={{width:"15%"}}>{moment(item.connected_at).format("YYYY-MM-DD H:m")}</td>
                                <td>{item.msisdn}</td>
                                {/* <td></td> */}
                                <td>{item.status}</td>

                                <td>{item.response}</td>
                                {/* <td> 
                                <label style={{ width: "30px" }} onClick={() => getChatHistory(item.msisdn,item.request_date_time)}>
                      <img src={Whatsap} alt="" />
                    </label>
                                   
                                  </td> */}
                              </tr>
                            </>
                          );
                        })
                      ) : (
                        <tr>
                          <td colspan="6">No Records To Display</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </TableContainer>
              </CardBody>
             { whatsappLst?.numOfPages>0&&
        <div style={{width:"30%",marginLeft: "auto"}}>
        <ResponsivePagination
      current={currentPage}
      total={whatsappLst?.numOfPages}
      onPageChange={(newPage )=>{getWhatsappList(newPage)}}
    />
    </div>
} 
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Detailedreports;
